import { useQuery, UseQueryOptions } from 'react-query';

import Contact from '@app/features/addressBook/types/Contact';
import { getContactsById } from '@app/store/transport-layer/document/address-book/contacts';

const useContactsById = (contactId: string, options?: UseQueryOptions<Contact, Error, Contact>) => {
  return useQuery<Contact, Error, Contact>({
    queryKey: ['address-book-contacts', contactId],
    queryFn: () => getContactsById(contactId),
    ...options,
  });
};

export default useContactsById;
